var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8195 6.98602C14.0096 7.18005 14.0096 7.49058 13.8195 7.68461L5.7779 15.7583C5.58498 15.953 5.35403 16.1059 5.09945 16.2074L0.769376 17.9639C0.584015 18.0385 0.372012 17.9953 0.230611 17.8541C0.0241544 17.7224 -0.0561655 17.4602 0.0410455 17.2353L1.75711 12.9041C1.85859 12.6494 2.01142 12.4184 2.20608 12.2255L10.2576 4.1717C10.3513 4.07723 10.4788 4.02409 10.6118 4.02409C10.7448 4.02409 10.8723 4.07723 10.966 4.1717L13.8195 6.98602ZM17.5609 1.0979L16.9024 0.439229C16.622 0.158411 16.2416 0.000464225 15.8448 0.000114826H15.0866C14.6829 -0.00488331 14.2943 0.153471 14.009 0.439229L12.2032 2.26555C12.013 2.45958 12.013 2.77011 12.2032 2.96414L15.0067 5.8084C15.1004 5.90287 15.2279 5.956 15.3609 5.956C15.4939 5.956 15.6214 5.90287 15.7151 5.8084L17.5609 3.99206C17.8466 3.70672 18.0049 3.31803 17.9999 2.91424V2.15577C17.9995 1.75888 17.8416 1.37837 17.5609 1.0979Z",
    fill: "#BBBCCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrey);
export default __webpack_public_path__ + "static/media/grey.230a526ba800f5ce0a8cca7155aa30f9.svg";
export { ForwardRef as ReactComponent };